// extracted by mini-css-extract-plugin
export default {"infoAlert":"JobPositionEditAuthorizedUsersButton-JobPositionAuthorizedUsersDialog__infoAlert--qAGDw"};